import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" to="https://www.holadayseedcompany.com/">
        Holaday Seed Co.
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
